import {
  IsNotEmpty,
  IsOptional,
} from "class-validator";

export class ClubDonationIntentDto {
  @IsNotEmpty()
  amount_cents: number;

  @IsNotEmpty()
  currency: string;
}
